import React, { useEffect } from "react";
import { init } from "ityped";
import { BoldText, Container, LightText, Text } from "./home";

export default function Home() {
  useEffect(() => {
    const myElement = document.querySelector("#myElement");
    init(myElement, {
      showCursor: true,
      strings: [
        "Software Engineer.",
        "DevOps Engineer.",
        "Full-Stack Developer.",
        "Mobile Developer.",
        "Agile Practitioner",
      ],
      backDelay: 1000,
    });
  }, []);

  return (
    <>
      <Container>
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
        <Text>
          <BoldText>Hello, I'm Shruti.</BoldText>&nbsp;I'm a&nbsp;
          <div id="myElement"></div>
        </Text>
        <LightText>Also, I am obsessed with music.</LightText>
      </Container>
    </>
  );
}
